import React from 'react'
import './Services.css'

const facts = [
  ['Location', 'Kinshasa, DR Congo'], ['Experience', '5+ years practical experience'], ['Availability', 'Remote · Contract · Full-time'], ['Languages', 'French · Swahili · English']
]

const Services = () => (
  <section className='about site-shell' id='About'>
    <div className='about-copy'>
      <span className='section-eyebrow'>About me</span>
      <h2 className='section-title'>Engineering software with operational depth</h2>
      <p>I am a Full-Stack Software Engineer focused on secure, scalable, and maintainable applications. I work across frontend interfaces, backend services, REST APIs, authentication, database architecture, real-time features, and Linux deployment.</p>
      <p>My background in networking, IT infrastructure, cybersecurity fundamentals, data analysis, and digital transformation helps me build software that is easier to operate, support, and improve in production.</p>
      <p>I am available for international remote roles, contract-based projects, product development, maintenance, performance optimization, and technical consulting.</p>
    </div>
    <aside className='about-card'>
      {facts.map(([label, value]) => <div key={label}><span>{label}</span><strong>{value}</strong></div>)}
    </aside>
  </section>
)
export default Services
